(function () {
  'use strict';

  /* @ngdoc object
   * @name turnover
   * @description
   *
   */
  angular
    .module('vcfinance.turnover', [
      'ui.router'
    ]);
}());
